import React, {useEffect} from "react";
import ActiveFilter from "../ActiveFilter/ActiveFilter";
import styled from "styled-components/macro";
import colors from "../../styles/variables/colors";
import {barActionAtom, barTitleAtom, filterActive, filteredNodesAtom, finishedAtom} from "../../atoms/atoms";
import {useAtom} from "jotai";
import {AnimatePresence, motion} from "framer-motion";
import ResultSlider from "./ResultSlider/ResultSlider";
import CategorizedResult from "./CategorizedResult";
import ResultActionButton from "./ResultActionButton";
type ResultPageComponent = () => JSX.Element;

export const ResultFilterBubbles = styled.div`
  padding: 10px 15px 0;
  background-color: ${colors.slate["10"]};
`;

export const CriteriaClaim = styled.span`
  font-family: "Helvetica Now Text W01 Bold", sans-serif;
  font-size: 18px;
  display: block;
  margin: 0 0 -5px 15px;
`;

export const ResultListDisplay = styled(motion.div)`
  background-color: ${colors.white.base};
  width: 100%;
  position: relative;
  height: auto;
  padding: 30px;
`;

export const ResultClaim = styled.h2`
  font-weight: 700;
  font-size: 25px;
  line-height: 1.222em;
  margin-bottom: 40px !important;
`;

const ResultPage: ResultPageComponent = () => {
  const [finished] = useAtom(finishedAtom);
  const [filteredNodes] = useAtom(filteredNodesAtom);
  const [active] = useAtom(filterActive);
  const [,setBarTitle] = useAtom(barTitleAtom);
  const [,setBarAction] = useAtom(barActionAtom)

  useEffect(() => {
    if (finished) {
      setBarAction('Werbeformate finden')
      setBarTitle(`Werbeformat${filteredNodes.length > 1 ? 'e' : ''}`)
    }
  }, [finished])

  useEffect(() => {
    if (finished && active) {
      setBarAction('Werbeformate finden')
      setBarTitle(`Werbeformat${filteredNodes.length > 1 ? 'e' : ''}`)
    }
  }, [active]);

  const Results = () => {
    return (
      <AnimatePresence>
        <ResultListDisplay
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          transition={{ ease: 'circOut', duration: 0.6}}
        >
          {filteredNodes.length > 1 ? (
            <ResultClaim>Diese {filteredNodes.length} Werbeformate passen zu Ihren Kriterien</ResultClaim>
          ) : (
            <ResultClaim>Dieses Werbeformat passt zu Ihren Kriterien</ResultClaim>
          )}
          <CategorizedResult />
        </ResultListDisplay>
      </AnimatePresence>
    )
  }

  return (
    <AnimatePresence>
      {(active && finished) &&
        <motion.div
          style={{position: "relative", overflowY: "auto"}}
          initial={{ height: 0 }}
          animate={{ height: 'auto' }}
          transition={{ ease: 'anticipate', duration: 0.4 }}
          exit={{ height: 0}}
        >
          <ResultFilterBubbles>
            <CriteriaClaim>Basierend auf diesen Kriterien:</CriteriaClaim>
            <ActiveFilter resultPage={true} />
          </ResultFilterBubbles>
          <Results />
          <ResultSlider />
          <ResultActionButton />
        </motion.div>
      }
    </AnimatePresence>
  );
}

export default ResultPage;
